"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESOLUTION_NAME = exports.DRM_NAME = exports.MANIFEST_NAME = void 0;
exports.MANIFEST_NAME = {
    DASH: 'dash',
    HLS: 'hls',
    MSS: 'mss',
    NATIVE: 'native',
};
exports.DRM_NAME = {
    WIDEVINE: 'widevine',
    PLAYREADY: 'playready',
    CLEARKEY: 'clearkey',
    FAIRPLAY: 'fairplay',
};
exports.RESOLUTION_NAME = {
    SD: 'SD',
    HD: 'HD',
    FULL_HD: 'Full HD',
    TV_4K: '4K',
};
//# sourceMappingURL=FormatNames.js.map